import React, { useEffect } from 'react';
import { IHelmet } from './helmet.interface';

export const useHelmet = (props: IHelmet) => {
  const { title } = props;
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    // add others tag head html
    return () => {
      document.title = prevTitle;
    };
  });
  return <></>;
};
